export default __webpack_public_path__ + "static/media/Bengali_education_f.d96b9ca3.wav";